import { render, staticRenderFns } from "./VDialogCoKey.vue?vue&type=template&id=4974c342"
import script from "./VDialogCoKey.vue?vue&type=script&lang=js"
export * from "./VDialogCoKey.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports